import React from "react";
import { Helmet } from "react-helmet";

export const Videointervista = () => {
    let src = "https://drive.google.com/file/d/1t1My0Xae3BL0VH7tF69tm3oHqkbD_j0q/preview";
    return (
        <>
            <title>
                <Helmet> Videointervista </Helmet>
            </title>
            <section id="videointervista" className="bgCream">
                <div className="container pb-5 pt-4 textBlue">
                    <h1 className="textBlue text-center fs-1"> Videointervista</h1>
                    <h3 className="textBlue text-center fs-3 my-3 mb-5">
                        Qui sotto puoi guardare il video della mia intervista radiofonica
                    </h3>
                    <div className="d-flex justify-content-center mt-3">
                        <iframe
                            src="https://drive.google.com/file/d/1t1My0Xae3BL0VH7tF69tm3oHqkbD_j0q/preview"
                            width="700"
                            height="480"
                            allow="autoplay"
                        ></iframe>
                    </div>
                </div>
            </section>
        </>
    );
};
